import ko from 'knockout';
import logger from '../../Vendor/inv-logger/logger';
import constants from '../constants';
import responseRepository from '../Repositories/responseRepository';
import contextData from '../contextData';

function AppealDetailsViewModel(params) {

  var self = this; // jshint ignore: line

  self.isResponseFormVisible = ko.observable(false);
  self.isCaptchaVisible = ko.observable(self.isCaptchaEnabled);
  self.isCaptchaEnabled = contextData.portalSettings.appealResponseCaptchaEnabled;

  self.isResponseAreaVisible = ko.observable(false);

  self.responseAreaLoading = ko.computed(function () {
    return !self.isCaptchaVisible() && !self.isResponseFormVisible();
  });

  self.languageCode = contextData.languageCode;
  self.captchaPublicKey = contextData.portalSettings.captchaPublicKey;
  // If captcha disabled then set value to default to pass the required validation
  self.captchaValue = ko.observable(self.isCaptchaEnabled ? null : 'Captcha disabled');
  self.captchaCallback = function () {
    if (self.isCaptchaVisible && self.captchaValue() !== null && self.captchaValue() !== 'Captcha disabled') {
      self.isCaptchaVisible(false);
      showResponseForm();
    }
  };

  self.appealPublicReference = params.appealPublicReference;
  self.responsePublicReference = null;
  self.responseType = constants.responseParentType.appeal;
  self.showResponseArea = function () {
    self.isResponseAreaVisible(true);

    if (self.isCaptchaEnabled) {
      self.isCaptchaVisible(true);
    } else {
      showResponseForm();
    }
  };

  function showResponseForm() {

    createResponse(self.appealPublicReference, self.captchaValue())
      .then(function (response) {
        self.responsePublicReference = response.responsePublicReference;
        self.isResponseFormVisible(true);
      })
      .catch(function (jqXhr) {

        return Promise.reject(jqXhr);
      });
  }

  function createResponse(appealPublicReference, captchaValue) {

    var parentDetails = {
      ParentPublicReference: appealPublicReference,
      ParentType: constants.responseParentType.appeal
    };

    return new Promise(function (resolve, reject) {
      responseRepository.createResponseWithCaptchaValidation(parentDetails, captchaValue)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (jqXhr) {

          logger.logAndThrowUntranslatedError(
            'An error occurred creating a response on appeal. Please try again later.',
            'Unable to get the response public identifier',
            jqXhr);

          reject(jqXhr);
        });
    });
  }
}

export default AppealDetailsViewModel;
